import * as Yup from "yup";

const SamvatSchema = Yup.object().shape({
  start_time: Yup.string().required("Start Date is required"),
  end_time: Yup.string().required("End Date is required"),
  value: Yup.number().required("Value is required"),
});

export default SamvatSchema;
